import config from 'config/config'

import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Comment, Header } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { users } = state.userAdmin
  return { users }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch)
}

class ProductLogs extends React.Component {
  logItems() {
    const { logEntries, users } = this.props
    if (!logEntries) return
    const logs =
      users.length > 0
        ? logEntries.map((logEntry) => ({
            time: new Date(logEntry.date).toLocaleString(),
            comment: logEntry.comment || 'kein Kommentar',
            user: users.find((user) => user.id === logEntry.user_id),
          }))
        : []
    return logs.map((logEntry, index) => (
      <Comment key={index}>
        <Comment.Avatar
          src={
            logEntry.user &&
            logEntry.user.avatar &&
            config.api_url + logEntry.user.avatar.thumb_url
          }
        />
        <Comment.Content>
          <Comment.Author as="a">
            {logEntry.user && logEntry.user.name}
          </Comment.Author>
          <Comment.Metadata>
            <div>{logEntry.time}</div>
          </Comment.Metadata>
          <Comment.Text>{logEntry.comment}</Comment.Text>
        </Comment.Content>
      </Comment>
    ))
  }

  render() {
    return (
      <div>
        <Header as="h3" dividing>
          Log
        </Header>
        <Comment.Group children={this.logItems()} />
      </div>
    )
  }
}

ProductLogs = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductLogs)
export default ProductLogs



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductLogs.jsx